import type {
  IResourceItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceItemResponseInstance'
import type {
  IDatabaseViewResponseInstance,
} from '@toolify/server/src/controllers/DatabaseViewController/types/IDatabaseViewResponseInstance'
import {
  getDatabaseViewResourceIconNameType,
} from '@toolify/server/src/services/ResourceService/functions/getDatabaseViewResourceIconNameType'

/**
 * What a DatabaseViewUpdated activity changes on the view's resource items (sidebar entries): the name,
 * and the icon when either the view's own icon or its type changed, because a view without an icon of
 * its own shows its type's default icon.
 */
export function getDatabaseViewResourceItemPatch(
  updatedKeys: string[],
  currentDatabaseView: Pick<IDatabaseViewResponseInstance, 'name' | 'type' | 'iconNameType'> | null | undefined,
): Partial<IResourceItemResponseInstance> {
  const resourceItemPatch: Partial<IResourceItemResponseInstance> = {}
  if(!currentDatabaseView) {
    return resourceItemPatch
  }
  if(updatedKeys.includes('name') && typeof currentDatabaseView.name === 'string') {
    resourceItemPatch.name = currentDatabaseView.name
  }
  if(updatedKeys.includes('iconNameType') || updatedKeys.includes('type')) {
    resourceItemPatch.iconNameType = getDatabaseViewResourceIconNameType(currentDatabaseView)
  }
  return resourceItemPatch
}
